import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './MobileNavigation.css';

const MobileNavigation = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { user } = useSelector((state) => ({ ...state }));
  const location = useLocation();

  // Show navigation on mobile devices, but exclude auth pages
  useEffect(() => {
    const checkMobile = () => {
      const isMobile = window.innerWidth <= 768;
      
      // Define authentication-related paths that should not show mobile navigation
      const authPaths = ['/login', '/reset', '/activate', '/register'];
      const isAuthPage = authPaths.some(path => location.pathname.startsWith(path));
      
      // Don't show navigation if user is not logged in or on auth pages
      const shouldHide = !user || isAuthPage;
      
      // Only show navigation on mobile devices and when user is logged in and not on auth pages
      setIsVisible(isMobile && !shouldHide);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, [location.pathname, user]); // Add user as dependency

  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/" || location.pathname === "/home";
    }
    if (path === "/friends") {
      return location.pathname === "/friends" || location.pathname.startsWith("/friends/");
    }
    return location.pathname === path || location.pathname.startsWith(path + "/");
  };

  if (!isVisible) return null;

  return (
    <nav className="mobile-navigation">
      <div className="mobile-nav-container">
        <Link 
          to="/" 
          className={`mobile-nav-item ${isActive("/") ? 'active' : ''}`}
          aria-label="Home"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
          </svg>
          <span>Home</span>
        </Link>

        <Link 
          to="/friends" 
          className={`mobile-nav-item ${isActive("/friends") ? 'active' : ''}`}
          aria-label="Friends"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 18.54 8H17c-.8 0-1.54.37-2.01 1l-1.7 2.26V15h-1.5v-6h-.15l-1.7-2.26A2.5 2.5 0 0 0 8.54 8H7c-.8 0-1.54.37-2.01 1L2.5 15H5v6h2v-6h1.5v6h2v-6H12v6h2v-6h1.5v6H18z"/>
          </svg>
          <span>Friends</span>
        </Link>

        <Link 
          to="/watch" 
          className={`mobile-nav-item ${isActive("/watch") ? 'active' : ''}`}
          aria-label="Watch"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"/>
          </svg>
          <span>Watch</span>
        </Link>

        <Link 
          to="/market" 
          className={`mobile-nav-item ${isActive("/market") ? 'active' : ''}`}
          aria-label="Marketplace"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>
          </svg>
          <span>Market</span>
        </Link>

        <Link 
          to="/profile" 
          className={`mobile-nav-item ${isActive("/profile") ? 'active' : ''}`}
          aria-label="Profile"
        >
          <div className="mobile-nav-profile">
            <img 
              src={user?.picture || "/images/default_pic.png"} 
              alt="Profile" 
              className="mobile-nav-avatar"
            />
          </div>
          <span>Profile</span>
        </Link>
      </div>
    </nav>
  );
};

export default MobileNavigation;
